/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { graphql } from 'gatsby';
import {
  StyledContentBlock,
  StyledSection,
  Title,
  Sectiontitle,
  SectionContent,
  FAQItem,
  FAQHeader,
  FAQContent,
  ToggleIcon,
  InlineLink,
} from './styled';

const AppLink = (chunks: React.ReactNode) => (
  <InlineLink
    href="https://bitcoincom.app.link/Rv4M3OyRMQb?_p=c11433dc9a0a7af2e11e90f5e0"
    target="_blank"
  >
    {chunks}
  </InlineLink>
);

const EmailLink = (chunks: React.ReactNode) => (
  <InlineLink href="mailto:support@bitcoin.com">{chunks}</InlineLink>
);

const FAQ = () => {
  const [expandedFAQs, setExpandedFAQs] = useState<number[]>([]);

  const toggleFAQ = (index: number) => {
    setExpandedFAQs(prevExpanded => {
      if (prevExpanded.includes(index)) {
        return prevExpanded.filter(faqIndex => faqIndex !== index);
      }

      return [...prevExpanded, index];
    });
  };

  const faqSections = [
    {
      questionId: 'home.faqSection.section1.question',
      answerId: 'home.faqSection.section1.answer',
    },
    {
      questionId: 'home.faqSection.section2.question',
      answerId: 'home.faqSection.section2.answer',
    },
    {
      questionId: 'home.faqSection.section3.question',
      answerId: 'home.faqSection.section3.answer',
    },
    {
      questionId: 'home.faqSection.section4.question',
      answerId: 'home.faqSection.section4.answer',
    },
  ];

  return (
    <StyledSection>
      <StyledContentBlock>
        <Title>
          <FormattedMessage id="home.faqSection.title" />
        </Title>

        {faqSections.map((faq, index) => (
          <FAQItem key={`faq-${index}`}>
            <FAQHeader onClick={() => toggleFAQ(index)}>
              <Sectiontitle>
                <FormattedMessage id={faq.questionId} />
              </Sectiontitle>

              <ToggleIcon>
                {expandedFAQs.includes(index) ? (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="31"
                    height="31"
                    viewBox="0 0 31 31"
                    fill="none"
                  >
                    <path
                      d="M15.6875 30.3477C23.9718 30.3477 30.6875 23.6319 30.6875 15.3477C30.6875 7.06338 23.9718 0.347656 15.6875 0.347656C7.40322 0.347656 0.6875 7.06338 0.6875 15.3477C0.6875 23.6319 7.40322 30.3477 15.6875 30.3477Z"
                      fill="#FF9500"
                    />
                    <path d="M21 16.6049V15.0879H10V16.6049H21Z" fill="black" />
                  </svg>
                ) : (
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="31"
                    height="31"
                    viewBox="0 0 31 31"
                    fill="none"
                  >
                    <path
                      d="M15.6875 30.3477C23.9718 30.3477 30.6875 23.6319 30.6875 15.3477C30.6875 7.06338 23.9718 0.347656 15.6875 0.347656C7.40322 0.347656 0.6875 7.06338 0.6875 15.3477C0.6875 23.6319 7.40322 30.3477 15.6875 30.3477Z"
                      fill="#FF9500"
                    />
                    <path
                      d="M16.2592 10.3477H14.7422V21.3477H16.2592V10.3477Z"
                      fill="black"
                    />
                    <path d="M21 16.6049V15.0879H10V16.6049H21Z" fill="black" />
                  </svg>
                )}
              </ToggleIcon>
            </FAQHeader>

            <FAQContent isExpanded={expandedFAQs.includes(index)}>
              <SectionContent>
                <FormattedMessage
                  id={faq.answerId}
                  values={{
                    appLink: AppLink,
                    emailLink: EmailLink,
                  }}
                />
              </SectionContent>
            </FAQContent>
          </FAQItem>
        ))}
      </StyledContentBlock>
    </StyledSection>
  );
};

export default FAQ;

export const headerFragment = graphql`
  fragment FAQ on Json {
    faqSection {
      title
      image {
        src
        alt
      }
      section1 {
        question
        answer
      }
      section2 {
        question
        answer
      }
      section3 {
        question
        answer
      }
      section4 {
        question
        answer
      }
    }
  }
`;
